import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function K() {
    const { useLang, useEffect, useState, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('solar60w');
    return (
        <div className={`solar-60w-K ${css['solar-60w-K']}`}>
            <p className="title">{t('sec11_title')}</p>
            <div className="content-box">
                <div className="left img-box">
                    <NextImage
                        // webpSrc={require('@publicLocal/solar-60w/pc/11_1.webp')}
                        src={require('@publicLocal/solar-60w/pc/11_1.jpg')}
                        alt={t('sec11_text1')}
                        aria-label={t('sec11_text1')}
                    />
                    <p className="text">{t('sec11_text1')}</p>
                </div>
                <div className="right">
                    <div className="top img-box">
                        <NextImage
                            // webpSrc={require('@publicLocal/solar-60w/pc/11_2.webp')}
                            src={require('@publicLocal/solar-60w/pc/11_2.jpg')}
                            alt={t('sec11_text2')}
                            aria-label={t('sec11_text2')}
                        />
                        <p className="text">{t('sec11_text2')}</p>
                    </div>
                    <div className="bottom">
                        <div className="r-b-l img-box">
                            <NextImage
                                // webpSrc={require('@publicLocal/solar-60w/pc/11_3.webp')}
                                src={require('@publicLocal/solar-60w/pc/11_3.jpg')}
                                alt={t('sec11_text3')}
                                aria-label={t('sec11_text3')}
                            />
                            <p className="text">{t('sec11_text3')}</p>
                        </div>
                        <div className="r-b-r img-box">
                            <NextImage
                                // webpSrc={require('@publicLocal/solar-60w/pc/11_4.webp')}
                                src={require('@publicLocal/solar-60w/pc/11_4.jpg')}
                                alt={t('sec11_text4')}
                                aria-label={t('sec11_text4')}
                            />
                            <p className="text">{t('sec11_text4')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
